<template>
    <div class="full">
        <div class="chapter" v-if="sectionList">
            <img src="../../assets/img/team/fu_tit01.png"
                 class="fuTit">
            <div class="main">
                <div class="know">针对章节薄弱知识点复习</div>
                <div class="weak">薄弱知识点，逐一突破</div>
                <div class="select"
                     @click="shift()">{{ select }}<img src="../../assets/img/team/blue_jiantou.png"
                         class="arrow1"></div>
                <ul>
                    <li class="every"
                        v-for="(item,index) in chapterList">
                        <router-link :to="{path: sectionList.sectionKpList[index].code}"
                                     append
                                     class="link"
                                     v-if="gclass[index] !== 'nopractice'">
                            <span class="selCon eslChapter">{{ item }}</span>
                            <div class="revright">
                                <span class="rev"
                                      :class="gclass[index]">{{ grade[index] }}</span>
                                <img src="../../assets/img/team/blue_jiantou.png"
                                     class="arrow"
                                     v-if="gclass[index] !== 'nopractice'">
                            </div>
                        </router-link>
                        <!--未练习-->
                        <div @click="noLearn()"
                             class="link"
                             v-if="gclass[index] === 'nopractice'">
                            <span class="selCon eslChapter">{{ item }}</span>
                            <div class="revright">
                                <span class="rev"
                                      :class="gclass[index]">{{ grade[index] }}</span>
                                <img src="../../assets/img/team/blue_jiantou.png"
                                     class="arrow"
                                     v-if="gclass[index] !== 'nopractice'">
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <img src="../../assets/img/team/fu_tit03.png"
                 class="fuTit">
        </div>
        <Picker :data='selData'
                :show="show"
                @close="show = !show"
                @change="changeHandler"></Picker>
        <!--toast提示-->
        <classMessage :message="info"
                      v-if="hint"></classMessage>
    </div>
</template>

<script>
// import { mapGetters } from 'vuex'
// import { TEAM, CHAPTER_INFO } from '@/store/modules/team'
import Picker from '@/components/picker/index'
import classMessage from '@/components/layer/classMessage'
export default {
    name: 'team',
    // computed: {
    //     ...mapGetters({
    //         allSection: TEAM
    //     })
    // },
    components: { Picker, classMessage },
    data: function () {
        return {
            chapterList: [],
            select: '',
            grade: [],
            gclass: [],
            vercode: '',
            bookList: [],
            selData: [
                {
                    title: '选择教材',
                    className: 'row-group',
                    currentIndex: 0,
                    flex: 5,
                    list: [],
                    textAlign: 'center'
                }
            ],
            show: false,
            sectionList: '',
            hint: false,
            info: '该章节未练习，无薄弱知识点'
        }
    },
    // created () {
    //     this.$store.dispatch(CHAPTER_INFO)
    // },
    mounted: function () {
        // setTimeout(() => {
        // 章节
        this.$http.post('/zy/m/s/report/learning2/sectionMasterNoVip', {}, {}).then((response) => {
            this.sectionList = response.data.ret
            for (let i = 0; i < this.sectionList.sectionKpList.length; i++) {
                this.chapterList.push(this.sectionList.sectionKpList[i].name)
                // 掌握情况
                switch (this.sectionList.sectionKpList[i].status) {
                    case 'EXCELLENT':
                        this.grade.push('优秀')
                        this.gclass.push('best')
                        break
                    case 'GOOD':
                        this.grade.push('良好')
                        this.gclass.push('good')
                        break
                    case 'COMMONLY':
                        this.grade.push('一般')
                        this.gclass.push('common')
                        break
                    case 'WEAK':
                        this.grade.push('薄弱')
                        this.gclass.push('weak1')
                        break
                    case 'NO_PRACTICE':
                        this.grade.push('未练习')
                        this.gclass.push('nopractice')
                        break
                }
            }
            // 默认展示课本版本及下拉框的课本列表
            this.bookList = this.sectionList.textbookList
            this.vercode = this.sectionList.selTextbookCode
            for (let i = 0; i < this.bookList.length; i++) {
                if (this.bookList[i].code === this.vercode) {
                    this.select = this.bookList[i].name
                    this.selData[0].currentIndex = i
                }
                this.selData[0].list.push(this.sectionList.textbookList[i].name)
            }
        }, (response) => {
            // to do
        })
        // }, 100)
    },
    methods: {
        shift: function () {
            this.show = true
        },
        changeHandler: function (msg) {
            this.select = msg[0]
            for (let i = 0; i < this.bookList.length; i++) {
                if (this.bookList[i].name === msg[0]) {
                    this.bookcode = this.bookList[i].code
                    this.selData[0].currentIndex = i
                }
            }
            // 清空上一个教材的数据
            this.chapterList = []
            this.grade = []
            this.gclass = []
            this.sectionList = 2
            this.$http.post('/zy/m/s/report/learning2/sectionMasterNoVip', {}, {
                params: { textbookCode: this.bookcode }
            }).then((res) => {
                // success callback
                this.sectionList = res.data.ret
                for (let i = 0; i < this.sectionList.sectionKpList.length; i++) {
                    // 默认展示章节列表
                    this.chapterList.push(this.sectionList.sectionKpList[i].name)
                    switch (this.sectionList.sectionKpList[i].status) {
                        case 'EXCELLENT':
                            this.grade.push('优秀')
                            this.gclass.push('best')
                            break
                        case 'GOOD':
                            this.grade.push('良好')
                            this.gclass.push('good')
                            break
                        case 'COMMONLY':
                            this.grade.push('一般')
                            this.gclass.push('common')
                            break
                        case 'WEAK':
                            this.grade.push('薄弱')
                            this.gclass.push('weak1')
                            break
                        case 'NO_PRACTICE':
                            this.grade.push('未练习')
                            this.gclass.push('nopractice')
                            break
                    }
                    // 各章节对应跳转地址
                    // this.sectionId.push(this.allSection.sectionKpList[i].code)
                    // if (this.gclass[i] !== 'nopractice') {
                    //     this.pathChange.push('/stureport/' + this.sectionId[i])
                    // } else {
                    //     this.pathChange.push({})
                    // }
                }
            }, (response) => {
                // error callback
            })
        },
        // 未练习提示
        noLearn: function () {
            this.hint = true
            setTimeout(() => {
                this.hint = false
            }, 3000)
        }
    }
}
</script>

<style scoped>
.full {
    width: 100%;
    min-height: 100%;
    position: absolute;
    background-color: #2ab7f7;
    top: 0;
}

.chapter {
    margin-top: 50px;
    margin-bottom: 30px;
}

.fuTit {
    width: 750px;
    height: 100px;
    display: block;
}

.main {
    width: 750px;
    background-image: url('../../assets/img/team/fu_tit04.png');
    background-size: 750px;
}

.know {
    font-size: 35px;
    font-weight: 600;
    text-align: center;
}

.weak {
    font-size: 25px;
    font-weight: 600;
    color: #839096;
    margin-top: 20px;
    text-align: center;
}

.select {
    color: #007aff;
    font-size: 28px;
    font-weight: 600;
    margin-top: 30px;
    text-align: center;
    /*margin-bottom: 15px;*/
}

.arrow1 {
    width: 16px;
    height: 24px;
    margin-left: 10px;
    vertical-align: baseline;
}

.arrow {
    width: 16px;
    height: 30px;
    vertical-align: middle;
}

.every {
    width: 622px;
    height: 100px;
    border: 4px solid #000000;
    border-radius: 15px;
    margin: 0 auto;
    font-size: 30px;
    line-height: 100px;
    background-color: #e1feff;
    margin-top: 20px;
    color: #000;
}

.selCon {
    font-weight: 600;
    width: 400px;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.eslChapter {
    padding-left: 26px;
}

.learn {
    color: #007aff;
    font-size: 30px;
    font-weight: 600;
    margin-right: 26px;
    float: right;
}

.revright {
    float: right;
    margin-right: 20px;
}

.rev {
    color: #1a88e6;
    display: inline-block;
    font-size: 27px;
    vertical-align: text-bottom;
    margin-right: 10px;
}

.best,
.good,
.common,
.weak1,
.nopractice {
    display: inline-block;
    border: 2.5px solid #00bb9d;
    background-color: #00bb9d;
    height: 30px;
    color: #ffffff;
    border-radius: 5px;
    line-height: 33px;
    font-size: 24px;
    width: 80px;
    text-align: center;
    vertical-align: middle;
}

.good {
    background-color: #7dca60;
    border: 2.5px solid #7dca60;
}

.common {
    background-color: #f8c438;
    border: 2.5px solid #f8c438;
}

.weak1 {
    background-color: #f14b40;
    border: 2.5px solid #f14b40;
}

.nopractice {
    background-color: #b5c3c9;
    border: 2.5px solid #b5c3c9;
    margin-right: 30px;
}

.link {
    color: #383d48;
}
</style>



// WEBPACK FOOTER //
// chapter.vue?f72f3946